import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import emitter from '@/utils/mitt';
import { ElMessage } from 'element-plus';
import { onUnmounted, ref } from 'vue';
import CheatDialog from './views/main/components/cheatDialog.vue';
// import 'element-plus/lib/el-message/'
import zhCn from 'element-plus/lib/locale/lang/zh-cn.js';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const visible = ref(false);
    const machineNo = ref('');
    const handleMessage = title => {
      ElMessage.error(title);
    };
    const handleReplacement = name => {
      visible.value = true;
      machineNo.value = name;
    };
    emitter.on('message', handleMessage);
    emitter.on('replacement', handleReplacement);
    onUnmounted(() => {
      emitter.off('message', handleMessage);
      emitter.off('replacement', handleReplacement);
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view), _createVNode(CheatDialog, {
          visible: visible.value,
          "onUpdate:visible": _cache[0] || (_cache[0] = $event => visible.value = $event),
          type: 2,
          machineNo: machineNo.value
        }, null, 8, ["visible", "machineNo"])]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});